// 30 FAQs across 7 categories. Direct from Phase 3 §7.
export const FAQ_CATEGORIES = [
    {
        key: "pool-cage-repair",
        title: "Pool Cage Repair",
        items: [
            {
                q: "Who fixes pool screens near me?",
                a: "A1 Screening repairs pool screens across Naples, Fort Myers, Cape Coral, Lehigh Acres, and Bonita Springs. Family-owned since 1999. Call 239-434-7306 or request a free estimate online.",
            },
            {
                q: "How long does pool cage repair take?",
                a: "Most small repairs in Naples can be done in a single visit. Full rescreens take longer depending on cage size and weather. We'll give you a clear timeline as part of your free estimate.",
            },
            {
                q: "What counts as a small pool cage screen repair?",
                a: "A small screen repair is usually 1–3 panels. A1 Screening can replace a few damaged panels when the rest of the pool cage or lanai screen is still in good condition.",
            },
            {
                q: "What counts as a medium screen repair?",
                a: "A medium repair is usually 4–10 panels. At that point, A1 Screening may explain both repair and rescreening options so the customer can choose what makes the most sense.",
            },
            {
                q: "What counts as a large screen repair?",
                a: "A large repair is usually around 11–20 panels. Depending on the age and condition of the screen, some homeowners may choose panel repair while others may consider a full rescreen.",
            },
            {
                q: "Should I repair panels or rescreen the whole pool cage?",
                a: "If only 1–3 panels are damaged, repair may be enough. If several panels are damaged, brittle, or aging, A1 Screening can explain both repair and full rescreening options so you can choose what makes the most sense.",
            },
            {
                q: "Does the location of the screen panel affect price?",
                a: "Yes. The height, location, and accessibility of the panel can affect pricing. Roof panels over the pool or panels above what a 24-foot ladder can safely reach may require special review.",
            },
            {
                q: "Do I need full rescreening or just a repair?",
                a: "One or two torn panels with healthy mesh elsewhere = usually a spot repair. Brittle, faded, or torn-in-multiple-places mesh = usually a full rescreen. We'll give you both options in writing.",
            },
            {
                q: "Do you repair structural cage damage like bent frames?",
                a: "Yes — bent frames, broken posts, super-gutters, and hardware are part of what we do. We'll inspect and tell you whether it's a repair or a rebuild.",
            },
            {
                q: "Will the new mesh keep no-see-ums out?",
                a: "It will if we use the right mesh for Southwest Florida — and we do. Generic mesh often isn't fine enough for Naples no-see-ums.",
            },
        ],
    },
    {
        key: "pool-rescreening",
        title: "Pool Rescreening",
        items: [
            {
                q: "How much does pool cage rescreening cost in Naples?",
                a: "Pool cage rescreening costs in Naples depend on the size of the enclosure, number of panels, screen material, access, storm damage, and whether structural repairs are needed. A1 Screening provides free estimates so homeowners can get accurate pricing for their specific pool cage or lanai.",
            },
            {
                q: "How often should pool cage screens be replaced in Florida?",
                a: "It varies — Southwest Florida sun, salt air, and storms shorten screen life compared to other parts of the state. If your mesh is brittle or faded, it's probably time.",
            },
            {
                q: "What makes pool screens wear out faster in Naples?",
                a: "Sun, salt air, wind, storms, pets, and pool chemistry all play a role. Naples conditions are tougher on screens than most folks expect.",
            },
            {
                q: "Will you reuse my old frames?",
                a: "If your frames are in good shape, yes. If they're bent, cracked, or rusted, we'll talk about repair or replacement during your free estimate.",
            },
        ],
    },
    {
        key: "lanai-screen-repair",
        title: "Lanai Screen Repair",
        items: [
            {
                q: "Who repairs lanai screens in Naples?",
                a: "A1 Screening repairs lanai screens in Naples and across Southwest Florida — torn panels, frames, screen doors, and full lanai rescreens.",
            },
            {
                q: "Can lanai screens be repaired panel by panel?",
                a: "Usually yes. If the rest of the mesh is healthy, panel-by-panel repair is the right move.",
            },
            {
                q: "Do you fix the screen door on my lanai?",
                a: "Yes — sliding doors, swing doors, rollers, hinges, mesh, and frames. Often a single visit.",
            },
        ],
    },
    {
        key: "storm-damage",
        title: "Storm Damage",
        items: [
            {
                q: "Can storm-damaged pool screens be repaired?",
                a: "Yes — most storm-damaged pool cages and screens can be repaired or rescreened. Storm repair availability may vary by schedule and season. Call 239-434-7306 to get on the list.",
            },
            {
                q: "What should I do right after a storm?",
                a: "Take photos of the damage, don't walk under sagging beams, and call us. We'll come look as soon as our schedule allows.",
            },
            {
                q: "Does insurance cover pool cage damage from a hurricane?",
                a: "It depends on your specific homeowners policy and deductible. Check with your insurer first — they can tell you what your policy covers and what documentation you'll need.",
            },
            {
                q: "Can I send photos for a storm estimate?",
                a: "Yes — and we recommend it. Photos help us move faster. Upload them on /upload-photos or text them to us after you call.",
            },
        ],
    },
    {
        key: "pricing-estimates",
        title: "Pricing & Estimates",
        items: [
            {
                q: "Are estimates really free?",
                a: "Yes — every estimate is free, written, and no-pressure.",
            },
            {
                q: "Do you charge to come look?",
                a: "No. The visit and the estimate are both free.",
            },
            {
                q: "Will I get pricing in writing?",
                a: "Yes — every estimate is in writing so you can take your time deciding.",
            },
            {
                q: "What is the fastest way to get a pool cage repair estimate?",
                a: "Call 239-434-7306 or upload a few photos at /upload-photos. Photos almost always speed things up.",
            },
        ],
    },
    {
        key: "service-areas",
        title: "Service Areas",
        items: [
            {
                q: "Does A1 Screening serve Naples?",
                a: "Yes — Naples is our home base. We've served Naples since 1999.",
            },
            {
                q: "Does A1 Screening serve Fort Myers?",
                a: "Yes — we serve Fort Myers from our Naples base.",
            },
            {
                q: "Does A1 Screening serve Cape Coral?",
                a: "Yes — we serve Cape Coral.",
            },
            {
                q: "Does A1 Screening serve Lehigh Acres?",
                a: "Yes — we serve Lehigh Acres.",
            },
            {
                q: "Does A1 Screening serve Bonita Springs?",
                a: "Yes — we serve Bonita Springs.",
            },
            {
                q: "Do you serve all Naples neighborhoods?",
                a: "Yes — Pelican Bay, Olde Naples, Park Shore, Lely, and the surrounding Naples neighborhoods.",
            },
        ],
    },
    {
        key: "scheduling-contact",
        title: "Scheduling & Contact",
        items: [
            { q: "What are your service hours?", a: "7:00 AM – 5:00 PM." },
            {
                q: "How do I schedule an estimate?",
                a: "Call 239-434-7306, fill the short estimate form, or upload photos at /upload-photos.",
            },
            {
                q: "Can I upload photos for an estimate review?",
                a: "Yes — photos can help the A1 Screening team understand visible damage before follow-up. Final recommendations and pricing are confirmed after technician review.",
            },
            {
                q: "Can photos help A1 Screening understand my repair?",
                a: "Yes. Photos can help the A1 Screening team get a clearer picture before follow-up — they don't replace an in-person look. Final recommendations and pricing are confirmed after technician review.",
            },
            {
                q: "Do you repair screen doors?",
                a: "Yes — sliding and swing screen doors, rollers, hinges, mesh, and frames. A1 Screening is also a certified approved installer for PCA Products custom screen doors.",
            },
            {
                q: "Do you repair condo screens?",
                a: "Yes — condo lanais, balconies, and screen doors. Property-manager-friendly. Condo pricing is confirmed after technician review.",
            },
            {
                q: "How do I reach the owner if I need to?",
                a: "Email info@a1screening247.com or call 239-434-7306 during business hours.",
            },
        ],
    },
    {
        key: "screen-doors",
        title: "Screen Doors & Z-Bar Trim",
        items: [
            {
                q: "How much does a standard screen door replacement cost?",
                a: "A standard 36\" × 80\" screen door replacement is approximately $275. This typically includes removing the old door, installing the new door, new screen, hinges, handles, closing plunger, and bottom bug sweep. Final pricing may vary based on job conditions and technician review.",
            },
            {
                q: "Do you offer custom screen doors?",
                a: "Yes. A1 Screening is a certified approved installer for PCA Products custom screen doors. Customers can explore custom screen door styles, sizes, and design options at pcaproducts.com, then contact A1 Screening for installation guidance and technician-reviewed pricing.",
            },
            {
                q: "What is Z-bar trim on a screen door?",
                a: "Z-bar trim is the trim around the edge of the screen door. If it needs to be replaced, it may add approximately $125 depending on the job.",
            },
            {
                q: "Is condo screen repair priced differently?",
                a: "Yes. Condo screen repair pricing can vary depending on the floor level, access, height, building rules, and job conditions. A third-floor unit is different from a high-rise unit, so final pricing is confirmed after technician review.",
            },
        ],
    },
];
